import React from 'react';
import { Card, CardTitle, CardText } from 'react-md';
import { aladb } from 'db'

import moment from 'moment';
import 'moment/locale/de';

import "./CardLastAccessed.css"

export default () => {
	const sqlData = aladb.db.exec("SELECT * FROM Log ORDER BY timestamp DESC LIMIT 1");
	const data = sqlData[0];

	const language = data.language.toLowerCase().replace(/en.*/g, 'Englisch').replace(/de.*/g, 'Deutsch');

/*	const bundleNo = "180501";
	const test = aladb.db.exec(`SELECT * FROM Log WHERE bundleNo = '${bundleNo}'`);
	test.forEach(t => {
		const dt = new Date(t.timestamp);
		const day = ('0' + dt.getDate()).slice(-2) + '.' + ('0' + (dt.getMonth() + 1)).slice(-2) + '.' + dt.getFullYear();
		const time = ('0' + dt.getHours()).slice(-2) + ":" + ('0' + dt.getMinutes()).slice(-2);
		console.log(`${day}\t${time}\t${t.serialNo}\t${t.mobile}\t${t.phone}\t${t.tablet}`);
	});

	*/

	return (
		<Card className="card-last-accessed">
			<CardTitle title={`Letzter Zugriff`}/>
			<CardText>
				<span><strong>{`${moment(data.timestamp).format('dd, L LT')}h`}</strong> auf Sticker <strong>{data.bundleNo && (data.bundleNo + '/')}{data.serialNo}</strong> mittels <strong>{data.mobile}</strong> ({language})</span>
			</CardText>
		</Card>
	);
};


// WEBPACK FOOTER //
// ./src/components/summary/cards/CardLastAccessed.jsx